import {
    ModuleWithProviders,
    NgModule
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ApiModule as AuthzAutorisationModule, Configuration as AuthzAutorisationConfig, MeService} from '../vendor/authz-api'
import {AuthzConfig} from './conf/conf';
import {reducer} from './store/reducers/authz.reducer';
import {AuthZEffects} from './store/effects/authz.effects';

import {
  AuthModule,
} from '@pcscol-portail/ng-auth';
import { AuthzRestService } from './services/authz-rest.service';
import { AuthzStubService } from './services/authz-stub.service';
import { AuthzNgRxAwareService, AuthzService } from './services/authz.service';

export function authzAutorisationConfig(config: AuthzConfig) {
  return new AuthzAutorisationConfig({
    basePath: config.url,
  });
}

export function authzServiceFactory(config: AuthzConfig, meService: MeService): AuthzNgRxAwareService {
  if (config.mode === 'stub') {
    return new AuthzStubService();
  } else {
    return new AuthzRestService(meService);
  }
}

@NgModule({
    declarations: [],
    imports: [
    CommonModule,
    AuthzAutorisationModule,
    AuthModule,
    // AuthGuard,
    StoreModule.forFeature('authZ', reducer),
    EffectsModule.forFeature([AuthZEffects]),
],
    providers: [
    ],
})
export class AuthzModule {
    static forRoot(config?: AuthzConfig): ModuleWithProviders<AuthzModule> {
        return {
            ngModule: AuthzModule,
            providers: [
                // Config API REST
                { provide: AuthzAutorisationConfig, useFactory: authzAutorisationConfig, deps: [AuthzConfig] },
                // Config Module Authz
                { provide: AuthzConfig, useValue: config },
                { provide: AuthzNgRxAwareService, useFactory: authzServiceFactory, deps: [AuthzConfig, MeService]},
                { provide: AuthzService, useExisting: AuthzNgRxAwareService },
            ],
        };
    }
}


